<template>
  <Card class="page-drug">
    <div style="display: flex; margin-bottom: 15px">
      <div style="flex: 1;">
      <el-input
        v-model="name"
        placeholder="请输入药品简称搜索"
        style="max-width: 350px"
        @keyup.enter.native="getQueryList"
      />
      <el-button
        type="primary"
        round
        style="margin-left: 30px"
        @click="getQueryList"
        >搜索</el-button
      >
      </div>
      <el-button
        type="primary"
        round
        style="margin-left: 230px"
        @click="addDrug"
        >新增药品</el-button
      >
    </div>
    <Table :columns="columns" :data="dataSource" :loading="loading">
      <template slot-scope="{ row }" slot="recur">
        {{formatDrug(row)}}
      </template>
      <template slot-scope="{ row }" slot="action">
        <el-button type="text" style="margin-right: 10px" @click="editDrug(row)">修改</el-button>
        <el-popconfirm title="确定删除该药品吗？" @confirm="deleteDrug(row)">
          <el-button slot="reference" type="text" class="error">删除</el-button>
        </el-popconfirm>
      </template>
    </Table>
    <div style="margin-top: 16px; text-align: right">
      <Page
        :total="total"
        :current="page"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
    <Modal
      v-model="show"
      :mask-closable="false"
      width="500"
      @on-cancel="cancel"
    >
      <div slot="header" style="text-align: center">
        <span>{{ cur.id ? "编辑药品" : "新增药品" }}</span>
      </div>
      <div
        style="
          max-height: calc(100vh - 450px);
          overflow-y: auto;
          z-index: 9;
          padding-right: 30px;
        "
      >

      <Form
          ref="formValidate"
          :model="cur"
          :rules="rules"
          :label-width="110"
          label-position="right"
          style="margin-left: -30px"
        >
          <FormItem label="药品简称" prop="name">
            <Input
              v-model.trim="cur.name"
              type="text"
              :maxlength="30"
              :disabled="read"
              placeholder="请填写药品简称"
            ></Input>
          </FormItem>
          <FormItem label="药品全称" prop="chinese_name">
            <Input
              v-model.trim="cur.chinese_name"
              type="text"
              :maxlength="30"
              :disabled="read"
              placeholder="请填写药品全称"
            ></Input>
          </FormItem>
          <FormItem label="用法" prop="usage">
            <Select v-model="cur.usage" placeholder="请选择药品用法">
              <Option v-for="u in usages" :key="u.value" :value="u.value">{{
                u.alias
              }}</Option>
            </Select>
          </FormItem>
          <FormItem label="单位" prop="unit">
            <Select v-model="cur.unit" placeholder="请选择药品单位">
              <Option v-for="u in units" :key="u.value" :value="u.value">{{
                u.alias
              }}</Option>
            </Select>
          </FormItem>
          <FormItem label="基础剂量" prop="dosage">
            <InputNumber
              v-model="cur.dosage"
              :precision="2"
              :min="0.01"
              :activeChange="false"
              :disabled="read"
              placeholder="请填写基础剂量"
              style="width: 100%"
            />
          </FormItem>
          <FormItem label="默认频率" prop="default_status">
            <Select v-model="cur.default_status">
              <Option :value="1" :key="1">是</Option>
              <Option :value="0" :key="0">否</Option>
            </Select>
          </FormItem>
          <FormItem
            required
            v-show="cur.default_status === 1"
            label="频率"
            prop="interval"
          >
            <div class="intervalWrap">
              <span>每</span>
              <Select
                v-model="cur.interval"
                placeholder="数"
                style="width: 70px; margin: 0 10px"
              >
                <Option
                  v-for="(n, i) in new Array(99)"
                  :key="i + 1"
                  :value="i + 1"
                  >{{ i + 1 }}</Option
                >
              </Select>
              <Select v-model="cur.freq" placeholder="周期" style="width: 70px">
                <Option v-for="f in freq" :key="f.value" :value="f.value">{{
                  f.text
                }}</Option>
              </Select>
            </div>
          </FormItem>
          <FormItem
            v-show="
              cur.default_status === 1 &&
              cur.interval &&
              (cur.freq === 'FREQ=MONTHLY;' || cur.freq === 'FREQ=WEEKLY;')
            "
            required
            :error="cur.freq_days && cur.freq_days.length ? '' : '请选择'"
            label="第几天"
          >
            <Select v-model="cur.freq_days" multiple>
              <Option
                v-for="(o, i) in new Array(freq_days)"
                :key="i + 1"
                :value="i + 1"
                >第{{ i + 1 }}天</Option
              >
            </Select>
          </FormItem>
          <FormItem
            v-show="cur.default_status === 1 && cur.freq"
            label="时间"
            prop="take_time"
            :error="cur.take_time && cur.take_time.length ? '' : '请选择'"
          >
            <caringTimePicker 
              :dataSource="cur.take_time"
              @save="saveTakeTime"
              @remove="removeTakeTime" />
          </FormItem>
          <FormItem label="常规用药" required prop="is_immutable">
            <Select v-model="cur.is_immutable" :disabled="read">
              <Option :key="0" :value="0">是</Option>
              <Option :key="1" :value="1">不是</Option>
            </Select>
          </FormItem>
          <FormItem label="厂商" prop="company">
            <Input
              v-model.trim="cur.company"
              type="text"
              :maxlength="255"
              placeholder="请填写药品厂商"
            ></Input>
          </FormItem>
          <FormItem label="简介" prop="intro">
            <Input
              v-model="cur.intro"
              :disabled="read"
              :rows="4"
              type="textarea"
              placeholder="请填写药品简介"
            ></Input>
          </FormItem>
        </Form>
      </div>

      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancel">取消</el-button>
        <el-button type="primary" round :loading="modalLoading" @click="save"
          >保存</el-button
        >
      </div>
    </Modal>
  </Card>
</template>
<script>
import {
  getMedicineListApi,
  editMedicineApi,
  deleteMedicineApi,
  addMedicineApi,
} from "../../api/resource";
import { getConfigApi } from "../../api/config"
import caringTimePicker from "../../components/caring-time-picker.vue";

const freq = [
  {
    text: "月",
    value: "FREQ=MONTHLY;",
  },
  {
    text: "周",
    value: "FREQ=WEEKLY;",
  },
  {
    text: "天",
    value: "FREQ=DAILY;",
  },
];
export default {
  components: {
    caringTimePicker,
  },
  data() {
    const r = {
      name: [
        {
          required: true,
          message: "请填写药品简称",
          trigger: "blur",
        },
        {
          required: true,
          message: "请填写药品简称",
          trigger: "change",
        },
      ],
      chinese_name: [
        {
          required: true,
          message: "请填写药品全称",
          trigger: "blur",
        },
        {
          required: true,
          message: "请填写药品全称",
          trigger: "change",
        },
      ],
      usage: [
        {
          required: true,
          message: "请填写药品用法",
          trigger: "change",
        },
      ],
      dosage: [
        {
          required: true,
          type: "number",
          min: 0.001,
          message: "请填写为正数的基础剂量",
          trigger: "blur",
        },
        {
          required: true,
          type: "number",
          min: 0.001,
          message: "请填写为正数的基础剂量",
          trigger: "change",
        },
      ],
      unit: [
        {
          required: true,
          message: "请填写药品单位",
          trigger: "change",
        },
      ],
      intro: [
        {
          required: true,
          message: "请填写药品简介",
          trigger: "blur",
        },
        {
          required: true,
          message: "请填写药品简介",
          trigger: "change",
        },
      ],
      default_status: [
        {
          required: true,
          type: "number",
          message: "请选择",
          trigger: "change",
        },
      ],
    };
    const r1 = {
      take_time: [
        {
          required: true,
          message: "请选择时间",
          type: 'array',
          trigger: "change",
        },
      ],
      interval: [
        {
          required: true,
          type: "number",
          message: "请选择频率",
          trigger: "change",
        },
      ],
      name: [
        {
          required: true,
          message: "请填写药品简称",
          trigger: "blur",
        },
        {
          required: true,
          message: "请填写药品简称",
          trigger: "change",
        },
      ],
      chinese_name: [
        {
          required: true,
          message: "请填写药品全称",
          trigger: "blur",
        },
        {
          required: true,
          message: "请填写药品全称",
          trigger: "change",
        },
      ],
      usage: [
        {
          required: true,
          message: "请填写药品用法",
          trigger: "change",
        },
      ],
      dosage: [
        {
          required: true,
          type: "number",
          min: 0.001,
          message: "请填写为正数的基础剂量",
          trigger: "blur",
        },
        {
          required: true,
          type: "number",
          min: 0.001,
          message: "请填写为正数的基础剂量",
          trigger: "change",
        },
      ],
      unit: [
        {
          required: true,
          message: "请填写药品单位",
          trigger: "change",
        },
      ],
      intro: [
        {
          required: true,
          message: "请填写药品简介",
          trigger: "blur",
        },
        {
          required: true,
          message: "请填写药品简介",
          trigger: "change",
        },
      ],
      default_status: [
        {
          required: true,
          type: "number",
          message: "请选择",
          trigger: "change",
        },
      ],
    };
    return {
      usages: [],
      units: [],
      freq,
      id: "",
      name: "",
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h("span",  `${params.row.intro}`);
          },
        },
        {
          title: "药品简称",
          align: "center",
          key: "name",
        },
        {
          title: "药品全称",
          align: "center",
          key: "chinese_name",
        },
        {
          title: "用法",
          align: "center",
          key: "usage",
        },
        {
          title: "基础剂量",
          align: "center",
          key: "dosage",
        },
        {
          title: "单位",
          align: "center",
          key: "unit",
        },
        {
          title: "频次",
          align: "center",
          key: "recur",
          slot: "recur",
          minWidth: 120
        },
        {
          title: "厂商",
          align: "center",
          key: "company",
        },
        {
          title: "操作",
          key: "action",
          width: 120,
          align: "center",
          slot: "action",
        },
      ],
      dataSource: [],
      cur: {
        name: "",
        chinese_name: "",
        intro: "",
        recur: "",
        take_time: [],
        usage: "",
        dosage: 1,
        unit: "",
        orders: "",
        is_immutable: 0,
        id: "",
        default_status: 0,
        company: "",
        freq_days: [],
        freq: "FREQ=DAILY;",
        interval: 1,
      },
      read: false,
      loading: false,
      show: false,
      modalLoading: false,
      total: 0,
      page: 1,
      size: 10,
      sizes: [10, 20, 30, 40, 50],
      open: false,
      time: "",
      r,
      r1,
    };
  },
  computed: {
    rules() {
      return this.cur && this.cur.default_status === 1 ? this.r1 : this.r;
    },
    freq_days() {
      if (this.cur.freq === "FREQ=MONTHLY;") {
        return this.cur.interval * 30;
      }
      if (this.cur.freq === "FREQ=WEEKLY;") {
        return this.cur.interval * 7;
      }
      return [];
    },
  },
  created() {
    this.getUnit();
    this.getUsage();
    this.getList();
  },
  methods: {
    getUnit() {
      getConfigApi({key: 'unit'}).then(res => {
        if (res.code === 0) {
          this.units = res.data;
        } else {
          this.$Message.error(res.message)
        }
      });
    },
    getUsage() {
      getConfigApi({key: 'usage'}).then(res => {
        if (res.code === 0) {
          this.usages = res.data;
        } else {
          this.$Message.error(res.message)
        }
      });
    },
    saveTakeTime(item) {
      this.cur.take_time.push(item);
    },
    removeTakeTime(item) {
      const index = this.cur.take_time.findIndex((t) => t.value === item.value);
      if (index !== -1) {
        this.cur.take_time = this.cur.take_time.filter((t, i) => i !== index);
      }
    },
    formatDrug(row) {
      const { interval, freq, freq_days } = row.info;
      const { take_time } = row
      let f = this.freq.find(f => f.value === freq);
      if (!interval && !freq && !f) {
        return row.recur
      }
      return `每${interval === 1 ? '' : interval}${f.text}${(f.text !== '天' && freq_days.length > 0) ? `的第${freq_days}天` : ''}的${take_time.split(',').map(item => item.substring(0,5))}`
    },
    onCurrentChange(current) {
      this.page = current;
      this.getList();
    },
    onSizeChange(size) {
      this.size = size;
      this.getList();
    },
    getQueryList() {
      this.page = 1;
      this.getList();
    },
    getList() {
      const { page, size, name } = this;
      this.loading = true;
      getMedicineListApi({ page, size, name })
        .then((res) => {
          this.loading = false;
          if (res.code === 0) {
            this.dataSource = res.data.map(row => {
              const express = row.recur ? row.recur.split(";") : [];
              let freq = this.freq.find(
                (f) => express.findIndex((e) => e + ";" === f.value) !== -1
              );
              freq = freq ? freq.value : "";
              let interval = express.find((e) => e.includes("INTERVAL="));
              interval = interval ? Number(interval.replace("INTERVAL=", "")) : 0
              let freq_days = express.find((e) =>
                freq === "FREQ=MONTHLY;"
                  ? e.includes("BYMONTHDAY=")
                  : e.includes("BYDAY=")
              );
              freq_days = freq_days
                ? freq_days.replace(
                    freq === "FREQ=MONTHLY;" ? "BYMONTHDAY=" : "BYDAY=",
                    ""
                  )
                : "";
              row.info = {
                freq,
                freq_days,
                interval
              }
              return row;
            })
            this.total = res["x-total-count"] || res.data.length;
            if(this.total && !this.dataSource.length && this.page > 1) {
              this.page = this.page - 1;
              this.getList();
            }
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    addDrug() {
      this.$refs.formValidate.resetFields();
      this.cur = {
        name: "",
        chinese_name: "",
        intro: "",
        recur: "",
        take_time: [],
        usage: "",
        dosage: 1,
        unit: "",
        orders: "",
        is_immutable: 0,
        id: "",
        default_status: 0,
        freq: "FREQ=DAILY;",
        company: "",
        freq_days: [],
        interval: 1,
      };
      this.showModal();
    },
    editDrug(row) {
      this.$refs.formValidate.resetFields();
      const { freq, freq_days, interval } = row.info;
      this.cur = Object.assign({}, JSON.parse(JSON.stringify(row)), {
        take_time: (row.take_time || "")
          .split(",")
          .filter((t) => t)
          .map((t) => ({ label: t && t.slice(0, 5), value: t })),
        dosage: isNaN(Number(row.dosage)) ? 0 : Number(row.dosage),
        interval: interval || 1,
        freq: freq || "FREQ=DAILY;",
        default_status: row.recur ? 1 : 0,
        freq_days: freq_days ? freq_days.split(",").map((d) => d - 0) : [],
      });
      this.showModal();
    },
    deleteDrug(row) {
      deleteMedicineApi(row.id).then((res) => {
        if (res.code === 0) {
          this.$Message.success("删除成功");
          this.getList();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    showModal() {
      this.show = true;
    },
    cancel() {
      this.show = false;
      this.$refs.formValidate.resetFields();
      this.modalLoading = false;
    },
    save() {
      this.$refs.formValidate.validate((valid) => {
        this.modalLoading = true;
        if (valid) {
          const cur = JSON.parse(JSON.stringify(this.cur));
          if (this.cur.default_status === 1) {
            const recur_days =
              cur.freq === "FREQ=MONTHLY;" ? "BYMONTHDAY=" : "BYDAY=";
            cur.recur =
              cur.freq +
              "interval=".toUpperCase() +
              cur.interval +
              ";" +
              (cur.freq_days.length
                ? recur_days + cur.freq_days.join(",")
                : "");
            cur.take_time = cur.take_time.map((t) => t.value.length > 5 ? t.value : t.value + ':00').join(",");
          } else {
            cur.recur = "";
            cur.take_time = "";
          }
          if (this.cur.id) {
            editMedicineApi(cur)
              .then((res) => {
                this.modalLoading = false;
                if (res.code === 0) {
                  this.$Message.success("编辑成功");
                  this.cancel();
                  this.getList();
                } else {
                  this.$Message.error(res.message);
                }
              })
              .catch(() => {
                this.modalLoading = false;
              });
          } else {
            delete cur.id;
            addMedicineApi(cur)
              .then((res) => {
                this.modalLoading = false;
                if (res.code === 0) {
                  this.$Message.success("新增成功");
                  this.cancel();
                  this.getList();
                } else {
                  this.$Message.error(res.message);
                }
              })
              .catch(() => {
                this.modalLoading = false;
              });
          }
        } else {
          this.$Message.warning("请填写相关内容");
          this.modalLoading = false;
        }
      });
    },
  },
};
</script>
<style lang="less">
.page-drug {
  .ivu-table-expanded-cell {
    background: #fff;
  }
  .error {
    color: #f56c6c;
    &:focus,
    &:hover {
      color: #f78989;
    }
  }
}
.intervalWrap {
  display: flex;
  align-items: center;
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    text-align: center;
    font-size: 14px;
  }
}
</style>
